import React, { useMemo } from 'react'
import { ICycleSession } from '../../../../types/cycleSession'
import { formatHours, getStatusLabel } from 'pages/Planning/utils/helpers'
import './styles.css'
import { toast } from 'react-toastify'
import { IStudyPlan } from 'store/modules/studyPlan/types'
import { planningApi } from 'pages/Planning/services/api'
import { useSelector } from 'react-redux'
import { RootState } from 'store/modules/rootReducer'
import { useRestartCycleTour } from 'pages/Planning/hooks/useRestartCycleTour'

interface ActivitiesProps {
  sessions: ICycleSession[]
  plan: IStudyPlan
}

/**
 * Componente que exibe a lista de sessões de estudo do ciclo
 */
const Activities: React.FC<ActivitiesProps> = ({ sessions, plan }) => {
  const { isDarkMode } = useSelector((state: RootState) => state.theme)

  // Hook para gerenciar o mini-tour do botão Reiniciar Ciclo
  useRestartCycleTour({ isDarkMode })

  const pendingSessions = useMemo(() => {
    return sessions.filter((s) => s.status !== 'done')
  }, [sessions])

  const completedSessions = useMemo(() => {
    return sessions.filter((s) => s.status === 'done')
  }, [sessions])

  const item = (session: ICycleSession) => (
    <div
      className={`cycle-activity-item ${session.status === 'completed' ? 'completed' : ''} ${
        session.current ? 'current' : ''
      }`}
    >
      <div className="cycle-activity-order">
        <span
          className="cycle-activity-bullet"
          style={{ backgroundColor: session.color || '#027A00' }}
        ></span>
        <div className="cycle-activity-order-indicator">
          {session.order.toString().padStart(2, '0')}ª
        </div>
        <span className="cycle-activity-subject">{session.module.subject}</span>
      </div>

      <div className="cycle-activity-content">
        <div className="cycle-activity-meta">
          <span className="cycle-activity-hours">{formatHours(session.hours)}</span>
          <span className="cycle-activity-status">{getStatusLabel(session.status)}</span>
        </div>
      </div>
    </div>
  )

  const handleRestartCycle = () => {
    planningApi
      .restartCycle(plan._id)
      .then(() => {
        toast.success('Ciclo reiniciado com sucesso')
        window.location.reload()
      })
      .catch((err: any) => {
        toast.error(err?.response?.data?.message || 'Erro ao reiniciar ciclo')
      })
  }
  return (
    <div className="cycle-activities span-4">
      <h3 className="cycle-activities-title">Sequência de estudo</h3>

      <div className="cycle-activities-list">
        {pendingSessions.length > 0 ? (
          <>
            {pendingSessions.map((session) => {
              return <div key={session._id}>{item(session)}</div>
            })}
          </>
        ) : (
          <div className="cycle-finished">
            <h3>Parabéns! Você concluiu todas as sessões de estudo deste ciclo.</h3>
            <p>Reinicie o ciclo para obter novas sessões de estudo.</p>
            <div className="cycle-finished-actions">
              <button
                className="cycle-session-button primary"
                onClick={() => handleRestartCycle()}
                data-tour="dashboard-restart-cycle"
              >
                Reiniciar ciclo
              </button>
            </div>
          </div>
        )}
        <div className="cycle-activity-separator">
          <div className="cycle-activity-separator-line"></div>
        </div>
        {completedSessions.map((session) => {
          return <div key={session._id}>{item(session)}</div>
        })}
      </div>
    </div>
  )
}

export default Activities
